import { createServerFn } from "@tanstack/react-start";
import { createClient } from "@supabase/supabase-js";
import type { Database } from "@/integrations/supabase/types";

function publicClient() {
  return createClient<Database>(
    process.env.SUPABASE_URL!,
    process.env.SUPABASE_PUBLISHABLE_KEY!,
    { auth: { storage: undefined, persistSession: false, autoRefreshToken: false } },
  );
}

export type ShippingZoneDTO = {
  code: string;
  name_en: string;
  name_bg: string;
  price_cents: number;
  currency: string;
  free_over_cents: number | null;
  eta_min_days: number;
  eta_max_days: number;
  color: string;
  sort_order: number;
};

export type ShippingCountryDTO = {
  iso2: string;
  iso3: string | null;
  name_en: string;
  name_bg: string;
  emoji_flag: string;
  zone_code: string;
  sort_order: number;
};

export const listShippingConfig = createServerFn({ method: "GET" }).handler(
  async () => {
    const sb = publicClient();
    const [{ data: zones, error: ze }, { data: countries, error: ce }] = await Promise.all([
      sb.from("shipping_zones").select("*").order("sort_order", { ascending: true }),
      sb
        .from("shipping_countries")
        .select("iso2,iso3,name_en,name_bg,emoji_flag,zone_code,sort_order")
        .order("sort_order", { ascending: true }),
    ]);
    if (ze) throw new Error(ze.message);
    if (ce) throw new Error(ce.message);
    return {
      zones: (zones ?? []) as ShippingZoneDTO[],
      countries: (countries ?? []) as ShippingCountryDTO[],
    };
  },
);